// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Message20 from './Message20';
import Message24 from './Message24';

type MessageProps = {
    variation: '20' | '24';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Message20,
    Message24,
};

const Message: FC<MessageProps> = ({ variation, ...props }) => {
    const variationKey = `Message${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Message" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Message;
